import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { Modal, Button, Paragraph, BottomSheet } from '@netexknowledge/smart-components';
import Media from 'react-media';
import * as messageAlert from '../../../actions/messageAlertAction';
import { MOBILE_MEDIA_QUERY } from '../../../utils/mobileUtils';
import ClassCodeBlock from '../sheets/ClassCodeBlock';

class ClassCodePopup extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.closeModal = this.closeModal.bind(this);
  }

  static propTypes = {
    classroom: PropTypes.object,
    classCode: PropTypes.string,
    classroomActions: PropTypes.any,
    classCodeIsOpen: PropTypes.any,
    handleCloseModal: PropTypes.func,
    inClassroom: PropTypes.bool,
    messageAlert: PropTypes.object
  };

  closeModal() {
    const { classroomActions, handleCloseModal, inClassroom } = this.props;
    if (!inClassroom) {
      classroomActions.setClassroomInfo();
    }
    classroomActions.setClassCodePopupOpen(false);
    if (handleCloseModal) {
      handleCloseModal();
    }
  }

  // Mobile: the same code block as the class header ⋮ sheet (ClassMoreSheet), with copy
  renderSheet() {
    const { classroom, classCodeIsOpen, messageAlert } = this.props;

    return (
      <BottomSheet
        open={Boolean(classCodeIsOpen)}
        onClose={this.closeModal}
        closeLabel={I18n.t('common.close')}
        overline={I18n.t('mobileSheets.classroom')}
        title={classroom.name}
      >
        <ClassCodeBlock
          classCode={classroom.classCode}
          onCodeCopied={() => messageAlert.success(I18n.t('mobileSheets.codeCopied'))}
        />
      </BottomSheet>
    );
  }

  render() {
    return <Media query={MOBILE_MEDIA_QUERY}>{isMobile => (isMobile ? this.renderSheet() : this.renderModal())}</Media>;
  }

  renderModal() {
    const { classroom, classCodeIsOpen } = this.props;

    return (
      <Modal
        id="class-code"
        title={I18n.t('classCodePopup.title')}
        active={classCodeIsOpen}
        onClickOutside={this.closeModal}
        children={
          <>
            <div className="classcode">{classroom.classCode}</div>
            <Paragraph className="text-grey-700">
              {I18n.t('classCodePopup.info1')} {I18n.t('classCodePopup.info2')}
            </Paragraph>
          </>
        }
        footer={<Button onClick={this.closeModal} label={I18n.t('common.close')}></Button>}
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    classCodeIsOpen: state.classrooms.selectedClassroom.classCodeIsOpen,
    classroom: state.classrooms.selectedClassroom.classroom,
    inClassroom: state.router.inClassroom,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassCodePopup);
